import { __decorate, __extends } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
import util from '@/utils/util';
import NoticeModal from './noticeTips.vue';
var noticeModal = util.mountVueComponent(NoticeModal);

var NoticeTips = function (_super) {
  __extends(NoticeTips, _super);

  function NoticeTips() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  NoticeTips.prototype.handleNotice = function () {
    noticeModal({
      parent: this
    });
  };

  __decorate([Prop({
    "default": {}
  })], NoticeTips.prototype, "formData", void 0);

  NoticeTips = __decorate([Component], NoticeTips);
  return NoticeTips;
}(Vue);

export default NoticeTips;